export const viewTitle = "Роли/Пользователи";
export const viewUniqKey = "accesses";
